import { SignUp } from '@clerk/clerk-react';
import { css, useTheme } from '@emotion/react';

import { fontFamilies, fontSizes, spacing } from '@/theme/tokens';

export function SignUpPage() {
  const theme = useTheme();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background: ${theme.colors.background};
        padding: ${spacing.xl};
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: ${spacing.sm};
          margin-bottom: ${spacing.xl};
        `}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="2" y="6" width="4" height="12" rx="1" fill={theme.colors.primary} />
          <rect
            x="8"
            y="3"
            width="4"
            height="18"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.7"
          />
          <rect
            x="14"
            y="8"
            width="4"
            height="8"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.5"
          />
          <rect
            x="20"
            y="5"
            width="4"
            height="14"
            rx="1"
            fill={theme.colors.primary}
            opacity="0.3"
          />
        </svg>
        <span
          css={css`
            font-family: ${fontFamilies.display};
            font-size: ${fontSizes.xl};
            font-weight: 700;
            color: ${theme.colors.text};
          `}
        >
          Sonematic
        </span>
      </div>
      <SignUp routing="path" path="/sign-up" />
    </div>
  );
}
